module.exports = __webpack_public_path__ + "static/media/up.4a1f33ea.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/up.png
 ** module id = 324
 ** module chunks = 0
 **/